import { jsFn } from '@/utils/jsFn'

const KEEPSTORAGE = 'KEEPSTORAGE'
const SETUPFUNCS = 'SETUPFUNCS'

export default {
    namespaced: true,
    state: {
        funcs: [ // 預計以後會開放的功能 以下以最大數量為主)
            { func: 'works', para: '2', get: null, exp: null, active: true, isDeadline: false}, // 作品收集任務數 (無授權預設 2，掃碼/IES5/個人授權會覆寫為 6)
            { func: 'clients', para: '50', get: null, exp: null, active: true, isDeadline: false }, // 連線人數 (掃碼改為 50)
            { func: 'pageqty', para: '50', get: null, exp: null, active: true, isDeadline: false }, // 頁面數
        ]
    },
    getters: {
        // 取得指定的功能設定
        getFunc: (state) => (func) => {
            let data = state.funcs.find(item => item.func === func)
            return data
        },
        getFuncAll: (state) => state.funcs
    },
    mutations: {
        [KEEPSTORAGE](state, data) {
            let keys = Object.keys(data)
            keys.forEach(key => {
                state[key] = data[key]
            })
        },
        [SETUPFUNCS](state, data) {
            data.forEach(d => {
                var i = state.funcs.findIndex((e) => e.func == d.func)
                if(i != -1){
                    state.funcs[i] = d
                }
            })
        },
    },
    actions: {
        /**
         * 設定開放的功能
         * @param {Object} data 
         */
        setup(context, data) {
            return new Promise((resolve) => {
                let funcData = []
                let nT = parseInt(Date.parse(new Date())/1000) // 用十碼計算

                // 防呆：略過未知的 func（如已移除的 aigpt）與缺少 exp 的項目
                let validData = (data || []).filter(d => !!d && d.exp != null && context.state.funcs.some(e => e.func === d.func))

                validData.forEach( (d) => {
                    let stateTmp = context.state.funcs.find( e => e.func === d.func)
                    let tmpExp = nT

                    let exp = d.exp
                    // 如果超過10碼調整為10碼
                    if(exp.toString().length > 10 ) exp = parseInt(exp/1000)

                    if((exp - tmpExp) > 0 && parseInt(stateTmp.para) < parseInt(d.para)) { // 檢查功能是否過期，沒過期比較大小值
                        stateTmp.para = d.para
                        stateTmp.exp = d.exp
                        stateTmp.get = d.get
                        stateTmp.isDeadline = true
                    }

                    funcData.push(stateTmp)
                })
                // 有其他權益傳入但未包含 works（authType 1 等）→ 補基本權益 2
                const hasOtherFunc = validData.some(d => d.func !== 'works')
                const worksIncluded = validData.some(d => d.func === 'works')
                const worksState = context.state.funcs.find(e => e.func === 'works')
                if (hasOtherFunc && !worksIncluded && worksState && worksState.get === null) {
                    let yearLater = nT + 3153600000
                    funcData.push({ ...worksState, para: 6, get: nT, exp: yearLater, isDeadline: true })
                }

                context.commit(SETUPFUNCS, funcData)
                context.dispatch('saveState') // 存到sessionStorage
                resolve(true)
            })
        },
        /** 
         * NOTE: 維持 vuex state 的資訊
        */
         keepState(context) {
            if(!jsFn.isEmpty(sessionStorage.getItem('funcsData'))) {
                let data = JSON.parse(decodeURIComponent(sessionStorage.getItem('funcsData'),'utf-8'))
                context.commit(KEEPSTORAGE, data)
            }
        },
        /**
         * NOTE: 儲存現在 state 的資訊
        */
        saveState(context) {
            let saveData = {
                funcs: context.state.funcs
            }
            sessionStorage.setItem('funcsData', encodeURIComponent(JSON.stringify(saveData), 'utf-8'))
        }
    }
}
